<template>
    <div id="folderSettingContainer" class="folder-setting-popup">
        <b-popover :show.sync="showSettingPopup" ref="popover" target="folderSetting" triggers="click"
            container="folderSettingContainer" :placement="bottomleft" :offset="180" :no-fade="true" @shown="onShown">
            <div class="content-section" v-if="folders.length > 0">
                <div class="content-row">Select folder(s) to search</div>
                <div class="filter-content-section">
                    <span @click="selectAll" class="select-all" style="cursor: pointer; color: #0095ff;">select all</span>
                    <div class="folder-section">
                        <b-form-group>
                            <b-form-checkbox-group plain stacked v-model="selectedFolders" @input="saveUsingCallback">
                                <template v-for="folder in folders">
                                    <b-form-checkbox :value="folder.uuid" :id="'settingsRow_checkbox_' + folder.uuid"><span class="check-description">{{ folder.displayName }}</span></b-form-checkbox>
                                </template>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="footer-section">
                    <div class="content-row-1 row pt-1 pb-2">
                      <div class="col-2" style="padding-right: 0px; max-width: 35px; flex: 0 0 35px;">
                        <b-form-checkbox
                            v-model="doNotOpenFolderSettingAutomatically"
                            value=true
                            unchecked-value=false
                            @click.native="onClick">
                          </b-form-checkbox>
                        </div>
                        <div class="col-10 pl-0 pr-0">
                          <span class="check-description">Do not open this page automatically</span>
                        </div>
                    </div>
                    <div class="content-row-1">Note that you can always access this page by clicking the 'Search Settings' icon explicitly.</div>
                </div>
            </div>
            
            <div class="loading-spinner">
                <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm">
                    <div class="text-center" style="color: #FFF">
                        <!--<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>-->
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                    </div>
                </b-modal>
            </div>
        </b-popover>
    </div>
</template>

<script>
    import '../../../assets/module/css/folderManagement/folderSettings.min.css'
    import { mapActions, mapState } from 'vuex'
    export default {
      name: 'folder-setting',
      props: ['showSettingPopup', 'selectedFolders', 'doNotOpenFolderSettingAutomatically'],
      data: () => {
        return {
          folders: [],
          isCurrentlySavingFlag: false
        }
      },

      mounted () {
        this.$refs.loadingModal.show()
        this.getLibraryPositionMapping()
      },

      methods: {
        ...mapActions([
          'loadAllLibraryForUser',
          'loadLibraryPositionMapping',
          'updateFolderSelectionToUserPreferences'
        ]),

        getLibraryPositionMapping () {
          this.loadLibraryPositionMapping().then(res => {
            this.getLibraryList()
          })
        },

        getLibraryList () {
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = this.sortLibrariesIntoStandardOrder(libraries)
            setTimeout(() => {
              this.toggleCheckbox()
              this.$refs.loadingModal.hide()
            }, 500)
          })
        },

        sortLibrariesIntoStandardOrder (libraries) {
          var sortedLibraryList = []
          for (var attr in this.libraryPositionMapping) {
            var value = this.libraryPositionMapping[attr]
            for (var i = 0; i < libraries.length; i++) {
              var library = libraries[i]
              if (this.libraryMatches(library, value)) {
                sortedLibraryList.push(library)
              }
            }
          }
          return sortedLibraryList
        },

        libraryMatches (library, value) {
          if (library.category === 'LearningSpace') {
            if (library.title === 'Shared With Me') {
              if (value === 'Shared') {
                return true
              }
            } else {
              if (value === 'Global') {
                return true
              }
            }
          }
          return library.category.indexOf(value) !== -1
        },

        selectAll () {
          var isSaveSetting = false
          $.each(this.folders, (index, library) => {
            if (library && $.inArray(library.uuid, this.selectedFolders) === -1) {
              this.selectedFolders.push(library.uuid)
              isSaveSetting = true
            }
          })
          $('div.filter-content-section *').prop('disabled', false)
          if (isSaveSetting) {
            this.saveUsingCallback()
          }
        },

        onClick (event) {
          if (event.target.tagName === 'INPUT') {
            this.saveUsingCallback()
          }
        },

        toggleCheckbox () {
          var selectedLibraries = this.selectedFolders
          const elem = 'settingsRow_checkbox_' + selectedLibraries[0]
          if (selectedLibraries.length === 1 && !$('#' + elem).is(':disabled')) {
            if (!$('#' + elem).is(':disabled')) {
              $('#' + elem).prop('disabled', true)
            }
          } else if (selectedLibraries.length > 1) {
            $('div.filter-content-section *').prop('disabled', false)
          }
          this.$emit('update:selectedFolders', selectedLibraries)
        },

        saveUsingCallback () {
          this.toggleCheckbox()
          this.$refs.loadingModal.show()
          $('.search-button-container').prop('disabled', true)
          if (this.showSettingPopup) {
            if (!this.isCurrentlySavingFlag) {
              this.isCurrentlySavingFlag = true
              setTimeout(() => {
                this.updateFolderSelection()
              }, 10)
            }
          }
        },

        updateFolderSelection () {
          var selectedLibraries = this.selectedFolders
          var userObject = JSON.parse(localStorage.getItem('userobj'))
          userObject.password = '*&^^&*'
          userObject.userPreferences.learningSpaces = selectedLibraries
          userObject.userPreferences.doNotOpenDiscoverySettingsAutomatically = this.doNotOpenFolderSettingAutomatically
          this.$parent.doNotOpenFolderSettingAutomatically = this.doNotOpenFolderSettingAutomatically
          this.updateFolderSelectionToUserPreferences({uuid: userObject.uuid, data: userObject}).then(res => {
            res.permission = this.permission
            localStorage.setItem('userobj', JSON.stringify(res))
            this.$store.commit('LOAD_LEARNING_SPACES', [])
            this.$store.commit('LOAD_USER_OBJECT', res)
            this.isCurrentlySavingFlag = false
            $('.search-button-container').prop('disabled', false)
            if (this.$refs.loadingModal) {
              this.$refs.loadingModal.hide()
            }
          })
        },

        onShown () {
          setTimeout(() => {
            this.$emit('after-shown')
          }, 1000)
        }
      },

      computed: {
        ...mapState({
          'libraryPositionMapping': state => state.search.libraryPositionMapping,
          'permission': state => state.user.permission
        })
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/search/components/FolderSetting.vue